import { analyticsAllowed } from "@/lib/cookieConsent";

/**
 * Thin wrapper around gtag('event', ...). Safe if GA hasn't loaded yet
 * or is blocked by the user's browser/ad-blocker.
 * No-ops when the visitor has declined analytics cookies.
 */
export function track(name, params = {}) {
  try {
    if (!analyticsAllowed()) return;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (_) {
    // no-op — analytics must never break the app
  }
}

/**
 * Standard params for the growth-tools funnel events
 * (tool_view / tool_start / tool_complete / report_download / report_email_optin).
 * Never pass user-entered financial values here — identifiers only.
 */
export function toolParams(tool) {
  return {
    tool_id: tool.id,
    tool_slug: tool.slug,
    tool_name: tool.name,
    tool_category: tool.category,
  };
}
export function trackTool(stage, tool) {
  track(stage, toolParams(tool));
}
